import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-create-from-experience-dialog',
  templateUrl: './create-from-experience-dialog.component.html',
  styleUrls: ['./create-from-experience-dialog.component.scss']
})
export class CreateFromExperienceDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
  }

  createTemplate() {
    this.dialogRef.close('create template');
  }
  createExperience() {
    this.dialogRef.close('create experience');
  }

}
